(() => {
  if (customElements.get('niplux-lp-support')) return;
  customElements.define('niplux-lp-support', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dialog = this.querySelector('dialog');
      const opener = this.querySelector('[data-spec-open]');
      opener?.addEventListener('click', () => {
        if (!this.dialog || this.dialog.open) return;
        this.dialog.showModal();
        this.previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        this.locked = true;
      }, options);
      this.querySelector('[data-spec-close]')?.addEventListener('click', () => this.closeDialog(), options);
      this.dialog?.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.closeDialog();
      }, options);
      this.dialog?.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.closeDialog();
      }, options);
      this.dialog?.addEventListener('close', () => {
        if (this.dialog.open) return;
        this.unlockScroll();
        if (opener?.isConnected) opener.focus({ preventScroll: true });
      }, options);
      this.querySelector('[data-faq-link]')?.addEventListener('click', (event) => {
        const faq = this.querySelector('.np-lp-support__faq');
        if (!faq) return;
        event.preventDefault();
        faq.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        faq.querySelector('summary')?.focus({ preventScroll: true });
      }, options);
    }
    closeDialog() {
      this.dialog.close();
      this.unlockScroll();
      this.querySelector('[data-spec-open]')?.focus({ preventScroll: true });
    }
    unlockScroll() {
      if (!this.locked) return;
      document.body.style.overflow = this.previousOverflow;
      this.locked = false;
    }
    disconnectedCallback() {
      this.controller?.abort();
      if (this.dialog?.open) this.dialog.close();
      this.unlockScroll();
    }
  });
})();
